// 옆 판의 머리 한 줄 — 아이콘·제목·(가운데 손)·닫기. 스레드 창(D12)과 같은 48px 자리다.
// 검색·요약부터 쓰고, 뒤따르는 옆 판들(캔버스·리스트·관리)이 같은 머리로 옮겨 온다.

import { X } from 'lucide-react'
import type { ReactNode } from 'react'
import { useT } from './i18n.ts'
import { IconButton } from './kit/button.tsx'

export function PanelHead(props: {
  /** 꾸밈 아이콘(lucide 요소, 16px). 읽히지 않는다. */
  icon: ReactNode
  title: ReactNode
  /** 없으면 닫기 단추도 없다 — 사이드바 이동 줄이 다시 눌러 닫는 판(활동·핀·나중에·안 읽음). */
  close?: (() => void) | undefined
  /** 닫기 단추의 이름. 기본 "닫기". */
  close_label?: string
  /** 제목과 닫기 사이, 오른쪽에 붙는 손들. */
  children?: ReactNode
}) {
  const t = useT()
  return (
    <header className="PanelHead">
      <span className="PanelHead-mark" aria-hidden>
        {props.icon}
      </span>
      <h3>{props.title}</h3>
      <span className="PanelHead-tools">{props.children}</span>
      {props.close !== undefined && (
        <IconButton
          size="sm"
          className="close"
          icon={<X aria-hidden />}
          label={props.close_label ?? t('닫기')}
          onClick={props.close}
        />
      )}
    </header>
  )
}
